import { render, staticRenderFns } from "./ParamsPanel.vue?vue&type=template&id=0574c24f&scoped=true"
import script from "./ParamsPanel.vue?vue&type=script&lang=js"
export * from "./ParamsPanel.vue?vue&type=script&lang=js"
import style0 from "./ParamsPanel.vue?vue&type=style&index=0&id=0574c24f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574c24f",
  null
  
)

export default component.exports